/* import __COLOCATED_TEMPLATE__ from './custom-rule-editor.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();